module.exports = __webpack_public_path__ + "img/制御工学3_8.2352ff29.png";